import React, { CSSProperties } from "react"
import { useField } from "formik"
import { NumericFormat } from "react-number-format"
import { FormHelperText, Grid, TextField } from "@mui/material"

type FormikCurrencyFieldProps = Readonly<{
    name: string
    label: string
    placeholder?: string | undefined
    errorMessage?: string
    fullWidth?: boolean
    inputTextAlign?: CSSProperties["textAlign"]
    containerDirection?: CSSProperties["flexDirection"]
    gap?: number
}>

export const FormikCurrencyField = ({
    name,
    label,
    placeholder,
    errorMessage,
    fullWidth = true,
    inputTextAlign = "right",
    containerDirection = "row",
    gap = 1,
}: FormikCurrencyFieldProps) => {
    const [field, _, helpers] = useField<string>(name)

    return (
        <Grid container gap={gap} flexDirection={containerDirection}>
            <TextField
                name={name}
                label={label}
                placeholder={placeholder}
                value={field.value}
                fullWidth={fullWidth}
                inputProps={{
                    style: { textAlign: inputTextAlign },
                }}
                onChange={(e) => {
                    helpers.setValue(e.target.value)
                }}
                InputProps={{
                    inputComponent: NumberFormatCustom as any,
                }}
                error={!!errorMessage}
            />
            {!!errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
        </Grid>
    )
}

interface NumberFormatCustomProps {
    inputRef: (instance: HTMLInputElement | null) => void
    onChange: React.FormEventHandler<HTMLInputElement>
    name: string
}

export const NumberFormatCustom: React.FC<NumberFormatCustomProps> = (props) => {
    const { inputRef, onChange, name, ...other } = props

    return (
        <NumericFormat
            {...other}
            name={name}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: name,
                        value: values.value,
                    },
                } as React.ChangeEvent<HTMLInputElement>)
            }}
            thousandSeparator={true}
            decimalScale={2}
            prefix=""
        />
    )
}
